import React, { useState, useEffect, useRef } from "react";
import GroupSupervisions from "./GroupSupervisions";
import IndividualSupervisions from "./IndividualSupervisions";
import ClinicalResourceLibrary from "../ClinicalResourceLibrary";
import { getADUsers } from "./../services/soar";
import SearchBox from "../common/SearchBox";
import Select from "../common/Select";

function Supervision() {
  const isMountedRef = useRef(true);
  const [safyUsers, setSafyUsers] = useState([]);
  const safyInfo = JSON.parse(localStorage.getItem("safyInfo"));
  const [providerSearch, setProviderSearch] = useState("");
  const [provider, setProvider] = useState({
    displayName: safyInfo.user.displayName.toLowerCase(),
    domainName: safyInfo.user.domainName.split("\\")[1].toLowerCase(),
  });
  const [loadStatus, setLoadStatus] = useState({});

  const handleProviderSearch = ({ currentTarget: input }) => {
    setProviderSearch(input.value);
  };

  const handleProviderChange = ({ currentTarget: input }) => {
    setProvider({
      displayName: safyUsers
        .filter((user) => user._id === input.value)[0]
        .firstLast.toLowerCase(),
      domainName: safyUsers
        .filter((user) => user._id === input.value)[0]
        ._id.split("@")[0]
        .toLowerCase(),
    });
  };

  useEffect(() => {
    if (loadStatus.loaded || loadStatus.loading || !safyInfo?.user?.email) {
      return;
    }

    const loadUsers = async () => {
      setLoadStatus({ loading: true });
      let response = await getADUsers();
      if (!isMountedRef.current || !response) {
        return;
      }

      if (process.env.REACT_APP_ENVIRONMENT === "Production") {
        console.log("Filter Out Logged In User", safyInfo.user.email);
        response = response.filter(
          (u) => u.internalemailaddress !== safyInfo.user.email
        );
      }

      const users = response
        .filter((u) => u.internalemailaddress)
        .map((u) => ({
          key: u.internalemailaddress,
          _id: u.internalemailaddress.toLowerCase(),
          name: `${u.fullname}`,
          firstLast: `${u.firstname} ${u.lastname}`,
          azureid: u.azureid,
        }));
      setSafyUsers(users);
      setLoadStatus({ loaded: true });
    };

    loadUsers();
  }, [safyInfo, loadStatus]);

  useEffect(() => {
    return () => (isMountedRef.current = false);
  }, []);

  return (
    <>
      {safyInfo.user.modules.includes("Admin") ? (
        <div className="rounded bg-warning p-2 mb-4">
          <div className="fw-bold">This section visible to Admins ONLY</div>
          <div className="row mt-4">
            <div className="col">
              <SearchBox
                label="Search by Provider Name"
                value={providerSearch}
                onChange={handleProviderSearch}
                placeholder="Search by Provider Name"
                clearSearch={() => setProviderSearch("")}
              />
            </div>
            <div className="col">
              <Select
                name="Provider"
                label="Select a Provider"
                value={provider._id}
                options={safyUsers.filter((provider) =>
                  provider.name
                    .toLowerCase()
                    .includes(providerSearch.toLowerCase())
                )}
                onChange={handleProviderChange}
              ></Select>
            </div>
          </div>
        </div>
      ) : null}
      <IndividualSupervisions safyUsers={safyUsers} provider={provider} />
      <GroupSupervisions safyUsers={safyUsers} provider={provider} />
      <ClinicalResourceLibrary />
    </>
  );
}

export default Supervision;
